import cloneDeep from 'lodash/cloneDeep'

const updatedLocationMaker = data => ({
  id: data.id,
  name: data.name,
  locationGroupId: data.locationGroupId,
  status: data.status,
  newItem: data.newItem,
  toDelete: data.toDelete,
  shapeType: data.shapeType,
  shape: data.shape,
})

const changePoint = (currentPointList, data) => {
  const cloneCurrentPointList = cloneDeep(currentPointList)
  return cloneCurrentPointList.map(point => {
    // 既存のポイントの場合（フェッチした時に存在する）

    if (!point.newItem.new) {
      if (point.id === data.id) {
        return updatedLocationMaker(data)
      }
      return point
    }

    // 新規ポイントの場合（フェッチした時に存在しない）
    if (point.newItem.id === data.newItem.id) {
      return updatedLocationMaker(data)
    }
    return point
  })
}

export default changePoint
